/**
 * @param {string[]} pathArr
 * @param {object} nestedObj
 * @returns {string}
 */

export default (pathArr, nestedObj = window.LANGS) => {
  return pathArr.reduce((obj, key) => (obj && obj[key] != null ? obj[key] : null), nestedObj)
}
